import HeroSection from './components/HeroSection';
import EmergencySection from './components/EmergencySection';
import ServicesSection from './components/ServicesSection';
import PortfolioSection from './components/PortfolioSection';
import AboutSection from './components/AboutSection';
import QuoteSection from './components/QuoteSection';
import ContactSection from './components/ContactSection';

export default function HomePage() {
  return (
    <div>
      <HeroSection />
      <EmergencySection />
      <ServicesSection />
      <PortfolioSection />
      <AboutSection />
      <QuoteSection />
      <ContactSection />
    </div>
  );
}
